import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import {
  getBrandStoreById,
} from "../../../services/StoreUsers/PostStoreUsers";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { addFranchise, updateFranchise } from "../../../services/FranchiseModal/Franchise";
import { Dropdown } from "primereact/dropdown";
import FinanceAdminMenu from "../../FinanceAdminMenu";

const FranchiseManagementCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const userRole = userProfileRole;

  const { storeLocalData } = getStoreLocalData();
    const countryCode = storeLocalData?.countryCode;


  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
 
  const [input, setInput] = useState({
    name: "",
    email: "",
    mobile: "",
    status: "ACTIVE",
    address: {
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      pin: "",
      city: "",
      state: "",
    },
  });

  useEffect(() => {
     if (item) {

       let savedMobileNo = item?.mobile;

       if (countryCode && item?.mobile?.startsWith(countryCode)) {
         savedMobileNo = item?.mobile?.replace(countryCode, "").trim();
       }

    setInput((prevState) => ({
      ...prevState,

      email: item?.email || "",
      mobile: savedMobileNo || "",
      name: item?.name || "",
      status: item?.status,
      address: {
        addressLine1: item?.address?.addressLine1 || "",
        addressLine2: item?.address?.addressLine2 || "",
        landmark: item?.address?.landmark || "",
        pin: item?.address?.pin || "",
        city: item?.address?.city || "",
        state: item?.address?.state || "",
      },
    }));
  }
  }, [item]);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [addressError, setAddressError] = useState("")
  const [statusError, setStatusError] = useState("");
    const [addressLineError, setAddressLineError] = useState("");
    const [stateError, setStateError] = useState("");
    const [pincodeError, setPincodeError] = useState("");

  const handleStatusChange = (selectedItem) => {
    // setStatusValue(selectedItem.value);
    setInput({
      ...input,
      status: selectedItem,
    });
  };

   const StatusList = [
     {
       name: "ACTIVE",
       value: "ACTIVE",
     },
     {
       name: "INACTIVE",
       value: "INACTIVE",
     },
   ];


  const handleMobileNumberChange = (number) => {
    // Perform input validation to allow only Indian mobile numbers
    let isValidPartial = false;
    let isValidFull = false;
    let requiredLength = 10;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and max 10 digits
      isValidPartial = /^[5-9]\d{0,9}$/.test(number) || number === "";
      isValidFull = /^[5-9]\d{9}$/.test(number);
      requiredLength = 10;

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and max 9 digits
      isValidPartial = /^5\d{0,8}$/.test(number) || number === "";
      isValidFull = /^5\d{8}$/.test(number);
      requiredLength = 9;
    }

    if (isValidPartial) {
      if (number.length === requiredLength) {
        setMobileNoError("");
      } else {
        setMobileNoError(`Please enter a ${requiredLength}-digit mobile number`);
      }

      setInput({
        ...input,
        mobile: number,
      });
    } else {
      setMobileNoError("Please enter a valid mobile number");
    }
  };

  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setNameError("");
    setEmailError("");
    setMobileNoError(""); 
    setStatusError("");
    setAddressError("")

    let isValid = true;
    if (!input.name) {
      setNameError("Store Name is Required");
      isValid = false;
    }
    if (!input.email) {
      setEmailError("Email is Required");
      isValid = false;
    }
    if (!input.mobile) {
      setMobileNoError("Mobile Number is Required");
      isValid = false;
    }
     if (!input.address.addressLine1) {
       setAddressLineError("Address Line 1 is Required");
       isValid = false;
     }

     if (!input.address.state) {
       setStateError("State Name is Required");
       isValid = false;
     }

     if (!input.address.pin) {
       setPincodeError("Pin Code is Required");
       isValid = false;
     }


    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          name: input.name,
          email: input.email,
          mobile: countryCode + input.mobile,
        };

        const UpdateData = {
          ...input,
          id: item?.id,
          name: input.name,
          email: input.email,
          mobile: countryCode + input.mobile,
          status: input.status,
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          addFranchise(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Franchise-List");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateFranchise(brandId, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Franchise-List");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Franchise-List")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="name"
              value={input.name}
              onChange={(e) => {
                setInput({
                  ...input,
                  name: e.target.value,
                });
                setNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {nameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {nameError}
              </p>
            )}

            <label htmlFor="name" className="text-lg" style={{ color: "blue" }}>
              Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="email"
              value={input.email}
              onChange={(e) => {
                setInput({
                  ...input,
                  email: e.target.value,
                });
                if (!isValidEmail(e.target.value)) {
                  setEmailError("Please enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {emailError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {emailError}
              </p>
            )}

            <label
              htmlFor="email"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Email Id <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="mobile"
              value={input.mobile}
              onChange={(e) => {
                handleMobileNumberChange(e.target.value);
              }}
              keyboardType="numeric"
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={10}
            />
            {mobileNoError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {mobileNoError}
              </p>
            )}

            <label
              htmlFor="mobile"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Mobile Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
              <div className="mx-4 mt-4 flex-1">
                <FloatLabel>
                  <InputText
                    id="addressLine1"
                    value={input.address.addressLine1}
                    onChange={(e) =>
                      setInput({
                        ...input,
                        address: {
                          ...input.address,
                          addressLine1: e.target.value,
                        },
                      })
                    }
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  />
                  {addressLineError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {addressLineError}
                    </p>
                  )}
      
                  <label
                    htmlFor="addressLine1"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    Address Line1 <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>
      
              <div className="mx-4 mt-4  flex-1">
                <FloatLabel>
                  <InputText
                    id="addressLine2"
                    value={input.address.addressLine2}
                    onChange={(e) =>
                      setInput({
                        ...input,
                        address: {
                          ...input.address,
                          addressLine2: e.target.value,
                        },
                      })
                    }
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  />
      
                  <label
                    htmlFor="addressLine2"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    Address Line2
                  </label>
                </FloatLabel>
              </div>
            </div>
      
            <div className="flex flex-1 mb-3">
              <div className="mx-4 mt-4 flex-1">
                <FloatLabel>
                  <InputText
                    id="city"
                    value={input.address.city}
                    onChange={(e) =>
                      setInput({
                        ...input,
                        address: {
                          ...input.address,
                          city: e.target.value,
                        },
                      })
                    }
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  />
      
                  <label htmlFor="city" className="text-lg" style={{ color: "blue" }}>
                    City
                  </label>
                </FloatLabel>
              </div>
      
              <div className="mx-4 mt-4  flex-1">
                <FloatLabel>
                  <InputText
                    id="state"
                    value={input.address.state}
                    onChange={(e) =>
                      setInput({
                        ...input,
                        address: {
                          ...input.address,
                          state: e.target.value,
                        },
                      })
                    }
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  />
                  {stateError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {stateError}
                    </p>
                  )}
      
                  <label
                    htmlFor="state"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    State <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>
            </div>
      
            <div className="flex flex-1 mb-3">
              <div className="mx-4 mt-4 flex-1">
                <FloatLabel>
                  <InputText
                    id="landMark"
                    value={input.address.landmark}
                    onChange={(e) =>
                      setInput({
                        ...input,
                        address: {
                          ...input.address,
                          landmark: e.target.value,
                        },
                      })
                    }
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  />
      
                  <label
                    htmlFor="landMark"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    LandMark
                  </label>
                </FloatLabel>
              </div>
      
              <div className="mx-4 mt-4  flex-1">
                <FloatLabel>
                  <InputText
                    id="pin"
                    value={input.address.pin}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setInput({
                          ...input,
                          address: {
                            ...input.address,
                            pin: value,
                          },
                        });
                      }
                    }}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    keyboardType="numeric"
                    maxLength={6}
                  />
      
                  {pincodeError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {pincodeError}
                    </p>
                  )}
      
                  <label htmlFor="pin" className="text-lg" style={{ color: "blue" }}>
                    Pin Code
                  </label>
                </FloatLabel>
              </div>
            </div>

      {item !== null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="status"
                value={input.status}
                onChange={(e) => handleStatusChange(e.target.value)}
                options={StatusList}
                optionLabel="name"
                placeholder="status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="status"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

{userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
      <AdminMenu setVisible={setVisible} visible={visible} />)}
    </div>
  );
};

export default FranchiseManagementCreate;
